const MODULE_NAME = 'root';

export const PUT_LANGUAGE = `[${MODULE_NAME}] PUT_LANGUAGE`;

export const GET_ME = `[${MODULE_NAME}] GET_ME`;
export const GET_ME_SUCCESS = `[${MODULE_NAME}] GET_ME_SUCCESS`;
export const GET_ME_ERROR = `[${MODULE_NAME}] GET_ME_ERROR`;
